module.exports = __webpack_public_path__ + "static/media/ringing-bell.f8953cca.svg";